import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/InviteCode/inviteCodeCopy";

/**
 * 邀请码（UI 文案叫 "Referral code"）相关文案 —— 走 scoped I18n，对齐 `signInPageCopy` 的形态。
 *
 * **命名提醒**：代码标识符统一 `invite`（后端 `OS-Invite-Code` / 路由 `/task/invite/:code`），
 * 只有用户可见文案叫 "Referral code"。见 `@utils/invite/inviteCode.ts` 顶部说明。
 */
export function createInviteCodeCopy(locale?: string) {
  const I18n = I18nUtil.createScoped(Translations, locale);
  return {
    /** 登录页底部：尚未有邀请码时的入口 */
    haveACode: I18n.t("Have a referral code?"),
    /** 填写页标题 */
    title: I18n.t("Add a referral code"),
    /** 填写页副标题 */
    subtitle: I18n.t("Enter the code a friend shared with you."),
    /** 输入框占位（Figma 错误态节点 I104980:320418 给的是这个；默认态节点残留着 email 占位） */
    placeholder: I18n.t("e.g. LXmWwn"),
    /** 提交按钮 */
    applyCode: I18n.t("Apply code"),
    /** 后端不认这个码时的错误提示 */
    invalidCode: I18n.t(
      "We don't recognise that code. Check it and try again.",
    ),
    /** applied 行：`Referral code ` + <code> + ` applied`（code 段用 semibold） */
    appliedPrefix: I18n.t("Referral code "),
    appliedSuffix: I18n.t(" applied"),
    /** 统一的「没识别到」后缀 —— 无效 / 限流 / 网络失败共用，不向用户区分原因 */
    notAppliedSuffix: I18n.t(" not applied"),
    back: I18n.t("Back"),
  } as const;
}

export type InviteCodeCopy = ReturnType<typeof createInviteCodeCopy>;

/** 默认（英文）实例，供无 locale 上下文的调用方与测试使用。 */
export const INVITE_CODE_COPY = createInviteCodeCopy();
